import { useEffect, useState } from "react";
import moment from "moment";

const MAX_CONTINUOUS_DRIVE = 4.5 * 60 * 60 * 1000;

export const useRealTimeTacho = (driveStatusInput, tick) => {
  const [violation, setViolation] = useState(false);
  const [continuousTime, setContinuousTime] = useState(0);

  useEffect(() => {
    if (!driveStatusInput) return;

    const driveStatus =
      typeof driveStatusInput === "string"
        ? JSON.parse(driveStatusInput)
        : driveStatusInput;

    if (!driveStatus?.isDriving || !driveStatus?.driveStartTime) {
      setViolation(false);
      setContinuousTime(0);
      return;
    }

    const start = moment(driveStatus.driveStartTime);
    const now = moment();
    const duration = now.diff(start);

    setContinuousTime(duration);
    setViolation(duration >= MAX_CONTINUOUS_DRIVE);
  }, [driveStatusInput, tick]);

  const formattedTime = moment.utc(continuousTime).format("HH:mm:ss");

  return { violation, continuousTime, formattedTime };
};